export namespace MoveListShared {
  export const enum Classes {
    CircleInfo = 'circle-info',
    MoveInfoIcon = 'move-info-icon',
    ThreeFoldIcon = 'redo',
    IconFont = 'icon-font-chess',
    MoveList = 'move-list',
  }

  export const enum Tags {
    EnPassantIcon = 'span',
  }

  export enum CssVariables {
    Color = '--nodeCustomColor',
    TooltipTop = '--tooltip-top',
  }
}
